import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { Pages } from '../../../models/blog.model'
import { TranslateService } from '@ngx-translate/core'
import { Meta, Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { Subscription } from 'rxjs'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { take } from 'rxjs/operators'
import { SquidexService } from '../../../services/squidex.service'
@Component({
  selector: 'flowaccount-business-registration-page',
  templateUrl: './business-registration-page.component.html',
  styleUrls: ['./business-registration-page.component.scss'],
})
export class BusinessRegistrationPageComponent implements OnInit, OnDestroy {
  public goodPointList = [
    {
      title: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.1.TITLE',
      description: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.1.DESCRIPTION',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_1_v2.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_1_v3.png',
      alt: 'ดำเนินการออนไลน์ทั้งหมด',
    },
    {
      title: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.7.TITLE',
      description: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.7.DESCRIPTION',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_5.png',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_5.png',
      alt: 'จองชื่อบริษัท',
    },
    {
      title: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.2.TITLE',
      description: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.2.DESCRIPTION',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_2_v2.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_2_v2.png',
      readMore: 'https://flowaccount.com/pricing',
      alt: 'ฟรี! FlowAccount แพ็กเกจสูงสุด',
    },
    {
      title: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.3.TITLE',
      description: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.3.DESCRIPTION',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_3_v2.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_3_v2.png',
      alt: 'ช่วยหาสำนักงานบัญชีที่เหมาะกับคุณ',
    },
    {
      title: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.4.TITLE',
      description: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LIST.4.DESCRIPTION',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_4_v1.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_4_v1.png',
      alt: 'มีทีมงานช่วยดูแลตลอด 365 วัน',
    },
  ]
  public page = Pages
  private languageChangeSubscription: Subscription
  private subscriptionService: Subscription
  private serviceList
  private BUSINESS_REGISTRATION_META_SEO_KEY = 'BUSINESS_REGISTRATION_META_SEO_KEY'
  constructor(
    public translate: TranslateService,
    private seoService: SEOService,
    private titleService: Title,
    private meta: Meta,
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
    public cdref: ChangeDetectorRef,
  ) {
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.meta.updateTag({ name: 'robots', content: 'index, follow' })
    })
  }

  ngOnInit(): void {
    // After scully builded
    if (isScullyGenerated()) {
      this.tstate
        .useScullyTransferState(this.BUSINESS_REGISTRATION_META_SEO_KEY, this.serviceList)
        .subscribe((data: object[]) => {
          this.serviceList = data
        })
    } else {
      // run every build
      this.getTotalService()
    }
  }

  async getTotalService() {
    this.subscriptionService = await this.squidexService
      .getContentSquidexApi('business-registration-pricing')
      .pipe(take(1))
      .subscribe((data: object[]) => {
        this.serviceList = data
        const pricing = this.serviceList[0].data.price.iv
        this.tstate.setState(this.BUSINESS_REGISTRATION_META_SEO_KEY, data)
        this.setMeta(pricing)
        this.cdref.markForCheck()
      })
  }
  ngOnDestroy() {
    this.languageChangeSubscription?.unsubscribe()
    this.subscriptionService?.unsubscribe()
  }
  private setMeta(pricing: string) {
    const title = this.translate.instant('BUSINESS_REGISTRATION.META_TITLE')
    const description = this.translate.instant('BUSINESS_REGISTRATION.META_DESCRIPTION', { pricing })
    const imageUrl = 'https://flowaccountcdn.com/new_landing/image/functions/business/business_header_v4.png'
    const canonicalUrl = 'https://flowaccount.com/business-registration'

    this.titleService.setTitle(title)
    this.seoService.createMetaTag(title, description)
    this.seoService.createOg(imageUrl, title, description)
    this.seoService.setCanonicalUrl(canonicalUrl)
    this.meta.updateTag({ name: 'robots', content: 'index, follow' })
  }
}
